import React from "react";
import { useTranslation, Trans } from "react-i18next";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "@/components/ui/AlertDialog";

interface GeneralErrorAlertDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const GeneralErrorAlertDialog = ({
  isOpen,
  onOpenChange,
}: GeneralErrorAlertDialogProps) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="general-error-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("global.generalError.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            <Trans
              i18nKey="global.generalError.message"
              components={{
                br: <br />,
                supportLink: (
                  <a
                    href="mailto:support@zeemee.com"
                    className="text-blue-primary hover:underline"
                  />
                ),
              }}
            />
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => onOpenChange(false)}>
            {t("global.close")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
